/**
 * ONDE O CANAL NÃO APARECE.
 *
 * A regra mora aqui, e não em cada ponto que mostra o botão, porque ela vai ser
 * consultada de três lugares — a barra do desktop, a gaveta e o limite de erro —
 * e três cópias divergiriam na primeira exceção nova.
 *
 * ─── DENTRO DA PROVA, NÃO ───────────────────────────────────────────────────
 *
 * `/student/simulation/:id` é o aluno respondendo. Um canal de relato ali é
 * distração no pior momento possível: são 263 alunos aplicando o Ciclo 2, e a
 * tela tem uma tarefa só.
 *
 * A exclusão vale por si, independentemente de o aluno ter o canal em todo o
 * resto do portal — e ele tem, porque são os alunos que mais esbarram em "não
 * carrega".
 *
 * Note que a rota do backend NÃO conhece esta regra, e é deliberado: ela é de
 * interface, não de permissão. Um aluno que descubra o endereço e mande um
 * relato durante a prova não fez nada de errado — só não vai ser convidado a
 * isso pela tela.
 */
export function podeRelatarNesteMomento(pathname: string): boolean {
  return foraDaProva(pathname);
}

/**
 * FORA DA PÁGINA DA PROVA — a mesma pergunta para o canal de relato e para o sino das notificações (19/10/2026): na
 * prova, nada que convide o aluno a sair dela.
 */
export function foraDaProva(pathname: string): boolean {
  return !/^\/student\/simulation\/[^/]+/.test(pathname);
}
